import { clientSession } from 'src/utils/session-storage';

export const VERSION_MISMATCH = 'version-mismatch';
export const STALE_QUIZ_REQUEST = 'stale-quiz-request';

function hasVersion(value: unknown): boolean {
  return value != null && value !== '';
}

// Parties, statements, and duels are published together. The quiz can continue
// only when both responses use the versionId saved from getParties.
export function matchesQuizVersion(responseVersionId: unknown, partiesVersionId: unknown): boolean {
  const savedVersion = clientSession.get()?.version;

  if (!hasVersion(savedVersion) || !hasVersion(responseVersionId) || !hasVersion(partiesVersionId)) {
    return false;
  }

  return responseVersionId === savedVersion && responseVersionId === partiesVersionId;
}
